document.addEventListener('click', function(e) {
  const btn = e.target.closest('.js-grid-cart');
  if (!btn) return;

  const variantId = btn.getAttribute('data-id');
  if (!variantId) return;

  if (btn.classList.contains('loading')) return;

  const originalHTML = btn.innerHTML;
  btn.classList.add('loading');
  btn.innerHTML = 'Adding...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(res => res.json())
  .then(data => {
    btn.classList.remove('loading');

    if (data.status === 422 || data.description) {
      btn.innerHTML = data.description || 'Unavailable';
      setTimeout(() => { btn.innerHTML = originalHTML; }, 2000);
      return;
    }

window.location.href = '/cart';


    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        document.querySelectorAll(
          '[data-cart-count], .cart-count-bubble span, #cart-icon-bubble span, .js-cart-count'
        ).forEach(el => {
          el.textContent = cart.item_count;
          el.closest('[aria-hidden]')?.setAttribute('aria-hidden', 'false');
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      });
  })
  .catch(() => {
    btn.classList.remove('loading');
    btn.innerHTML = 'Error — try again';
    setTimeout(() => { btn.innerHTML = originalHTML; }, 2000);
  });
});